<template>
  <div class="product-price-tutorial-page col-block" :style="{ height: '100%', width: '100%', 'min-width': '1350px' }">
    <tutorialMain
      :params="{
        renderItem: renderItem,
        display: display,
        toggle: toggle
      }"
    ></tutorialMain>
  </div>
</template>

<script>
import tutorialMain from '../../components/tutorial/main'

export default {
  components: {
    tutorialMain
  },
  computed: {
    // static
    renderItem () {
      return {
        '零售價格分析與指標': true,
        '零售價格分析操作教學說明': true
      }
    },
    display () {
      return {
        '零售價格分析與指標': false,
        '零售價格分析操作教學說明': true
      }
    },
    toggle () {
      return {
        '零售價格分析與指標': null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/productPrice/tutorial.vue